import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  FormHelperText,
} from "@mui/material";
import { GlobalTextFieldStyles } from "../../../theme/global-styles";
import { AtMultiselectProps } from "./at-multiselect.types";
import { useId } from "react";

export const AtMultiselect = ({
  label,
  value,
  error,
  disabled,
  onChange,
  options,
  helpText,
  required,
}: AtMultiselectProps) => {
  const id = useId();

  const handleChange = (
    event: SelectChangeEvent<AtMultiselectProps["value"]>,
  ) => {
    const {
      target: { value },
    } = event;
    const selectedValues = typeof value === "string" ? value.split(",") : value;
    onChange(selectedValues);
  };

  return (
    <>
      <GlobalTextFieldStyles />
      <FormControl fullWidth>
        <InputLabel
          id={`${id}-label`}
          required={required}
          disabled={disabled}
          error={error}
        >
          {label}
        </InputLabel>
        <Select
          id={`${id}-select`}
          labelId={`${id}-label`}
          multiple
          value={value}
          onChange={handleChange}
          label={label}
          input={<OutlinedInput label={label} size="small" />}
          variant="outlined"
          size="small"
          fullWidth
          required={required}
          error={error}
          disabled={disabled}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
        {helpText && (
          <FormHelperText error={error} disabled={disabled} required={required}>
            {helpText}
          </FormHelperText>
        )}
      </FormControl>
    </>
  );
};
